import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ORIGIN_BUTTON, TYPE_BUTTON } from "../../model/filters-constants";
import { MatSelect } from "@angular/material/select";
import { MatOption } from "@angular/material/core";

@Component({
    selector: "im-additional-filters-dialog",
    templateUrl: "./additional-filters-dialog.component.html",
    styleUrls: ["./additional-filters-dialog.component.scss"],
    standalone: false
})
export class AdditionalFiltersDialogComponent implements OnInit {
  @ViewChild("typeSelect") typeSelect: MatSelect;
  @ViewChild("originSelect") originSelect: MatSelect;

  public dialogResult: any;

  constructor(
    private dialogRef: MatDialogRef<AdditionalFiltersDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
  ) {}

  ngOnInit(): void {
    this.mapInitialData();
  }

  private mapInitialData(): void {
    this.dialogResult = {
      type: this.dialogData.typeFilter.value,
      origin: this.dialogData.originFilter.value,
      reference: this.dialogData.referenceFilter.value,
      creationDateTo: this.dialogData.creationDateToFilter.value,
      creationDateFrom: this.dialogData.creationDateFromFilter.value,
      closeDate: this.dialogData.closeDateFilter.value,
      vesselName: this.dialogData.vesselNameFilter.value,
    };
  }

  getOriginSelection(event: any): void {
    this.dialogResult.origin = event.value;
  }

  getTypeSelection(event: any): void {
    this.dialogResult.type = event.value;
  }

  clearInspectionReferenceField() {
    this.dialogResult.reference = "";
  }

  clearCreationDateField() {
    this.dialogResult.creationDateTo = "";
    this.dialogResult.creationDateFrom = "";
  }

  clearCloseDateField() {
    this.dialogResult.closeDate = "";
  }

  clearVesselNameField() {
    this.dialogResult.vesselName = "";
  }

  public clearDropDownFieldEvent(event: Event): void {
    event.stopPropagation();
    switch ((event.currentTarget as any).id) {
      case ORIGIN_BUTTON:
        this.clearDropDownField(this.originSelect);
        this.dialogResult.origin = "";
        break;
      case TYPE_BUTTON:
        this.clearDropDownField(this.typeSelect);
        this.dialogResult.type = "";
        break;
      default:
        break;
    }
  }

  private clearDropDownField(matSelect: MatSelect): void {
    matSelect?.options?.forEach((data: MatOption) => data.deselect());
  }

  cancel() {
    this.dialogRef.close(null);
  }

  apply() {
    this.dialogRef.close(this.dialogResult);
  }
}
